import { render, staticRenderFns } from "./day-absent.vue?vue&type=template&id=06b96996&"
import script from "./day-absent.vue?vue&type=script&lang=js&"
export * from "./day-absent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports